import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import ErrorMessage from '@/forms/_common/ErrorMessage';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { EventTitleEditDialog } from '@/features/share-event';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function Launcher(props) {
  const config = useDialogConfig();

  const event = useConnect('event.byId', {
    id: config.params.eventId
  });

  if (event.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (event.state === PayloadStates.NOT_FOUND) {
    return (
      <ErrorMessage>
        Event not found.
      </ErrorMessage>
    );
  }

  if (event.state === PayloadStates.ERROR_FETCHING) {
    return (
      <ErrorMessage>
        An error occurred while loading the event.
      </ErrorMessage>
    );
  }

  return (
    <EventTitleEditDialog
      event={event}
      onCancel={props.onClose}
    />
  );
}
